module["exports"] = [
  "#####"
];



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/fr/address/postcode.js
 ** module id = 674
 ** module chunks = 0
 **/